export const NAME = 'reporting';